module.exports = __webpack_public_path__ + "static/NI-MASTER-logo-15071ba3c70603946de05e724b15a9c5.png";